import { NgModule } from '@angular/core';
import { SharedModule } from '@shared';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from './license-date-format';
import { ReusableModule } from '../reusable/reusable.module';
import { AdministratorApplicationComponent } from './administrator-application/administrator-application.component';
import { ManageInHomeCareChangeComponent } from './manage-in-home-care-change/manage-in-home-care-change.component';
import { InHomeCareComponent } from './manage/in-home-care.component';
import { ManagementExperienceComponent } from './management-experience/management-experience.component';
import { ProfessionalExperienceComponent } from './professional-experience/professional-experience.component';
import { CommonModule } from '@angular/common';
import { InHomeCareRoutingModule } from './in-home-care-routing.module';
import { PaymentsModule } from '../payments/paymentsmodule';
import { InHomeCareChangeDialogComponent } from './in-home-care-change/in-home-care-change-dialog.component';
import { ExportInHomeCareLicenseDialogComponent } from './dialog-export-in-home-care-license/dialog-export-in-home-care-license.component';
import { InHomeCareReportsComponent } from './in-home-care-reports/in-home-care-reports.component';
import { InHomeCareManagementComponent } from './in-home-care-management/in-home-care-management.component';
import { InHomeCareAssignedComponent } from './in-home-care-assigned/in-home-care-assigned.component';
import { InHomeCareClaimsComponent } from './in-home-care-claims/in-home-care-claims.component';

const COMPONENTS = [
  InHomeCareComponent,
  AdministratorApplicationComponent,
  ManagementExperienceComponent,
  ProfessionalExperienceComponent,
  ManageInHomeCareChangeComponent,
  InHomeCareChangeDialogComponent,
  ExportInHomeCareLicenseDialogComponent,
  InHomeCareReportsComponent,
  InHomeCareManagementComponent,
  InHomeCareAssignedComponent,
  InHomeCareClaimsComponent
]

const PIPES = []

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [
    CommonModule,
    SharedModule,
    ReusableModule,
    InHomeCareRoutingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PaymentsModule
  ],
  exports: [...PIPES],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ]
})
export class InHomeCareModule { }
